// tslint:disable-next-line:no-namespace
export const DOMAIN = {
  PUBLIC: 'public',
  ONBOARDING: 'onboarding',
  AUTH: 'auth',
  PRIVATE: 'private',
  DASHBOARD: 'dashboard',
  ADMIN: 'admin',
}
